import { jsx as _jsx } from "react/jsx-runtime";
import { Close } from '@nike/nike-design-system-icons';
export function IconCloseButton({ onClick, ariaLabel = 'Remove', showOnHover = true, hoverGroupClass = 'group-hover' }) {
    const hoverClasses = showOnHover
        ? `opacity-0 ${hoverGroupClass}:opacity-100 transition-opacity`
        : '';
    return (_jsx("button", { type: "button", "aria-label": ariaLabel, onClick: onClick, className: `w-6 h-6 p-0 border-none bg-transparent cursor-pointer rounded flex items-center justify-center hover:bg-[#F7F7F7] ${hoverClasses}`, children: _jsx(Close, { className: "w-4 h-4 text-[#999999]" }) }));
}
